import { CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';
import genererGuid from '@/services/general/genererGuid';
import { ANNEE, SENS_VENTE } from '@/configuration/devisConf';
import booleanConverter from '@/services/import/General/booleanConverter';
import { padStart } from 'lodash';
import formatDate from '@/services/general/formatIsoDate';
import moment from 'moment';
import calculArrondi from '@/services/calcul/calculArrondi';
import { findConfrere, generateRef } from './services';

function gestionAdresse(adresse) {
  return {
    adresse1: adresse?.substring(0, 100),
    adresse2: adresse?.substring(100, 200),
    adresse3: adresse?.substring(200, 300),
  };
}

function genererProduit(ligne, supportCommercial, produits) {
  const liaisons = [];
  if (ligne.referenceProduitLocation) {
    const produit = produits.find(
      p => p.reference.toLowerCase() === ligne.referenceProduitLocation.toLowerCase(),
    );
    if (produit) {
      const liaison = {
        libelle: produit.libelle,
        dateDebut: formatDate(moment().toDate()),
        dateFin: null,
        quantite: calculArrondi(ligne.quantiteLocation),
        uniteVente: ANNEE,
        prixUnitaire: ligne.prixUnitaireLocation,
        produitEnfantId: produit.id,
      };
      liaisons.push(liaison);
    }
  }
  const adresse = gestionAdresse(ligne.adresse);

  return {
    id: genererGuid(),
    reference: ligne.produit,
    libelle: ligne.libelleProduit,
    confrere: ligne.confrere,
    agenceId: null,
    cgvs: [],
    liaisonsTarif: liaisons,
    entiteCommerciale: {
      enseignesMarques: [],
      nbHabitantsAireUrbaine: null,
      audienceAn: null,
      nbContactsAn: null,
      audienceHebdo: null,
      nbContactsHebdo: null,
      localite: null,
      revenuNetMenageAn: null,
      surface: null,
      indiceCsp: null,
    },
    schemaComptableId: null,
    schemaComptable: null,
    produitFace: {
      codePanneau: ligne.codePanneau,
      format: ligne.format,
      materielType: ligne.typeDeMateriel,
      azimut: ligne.azimut,
      adresse: {
        adresse1: adresse.adresse1,
        adresse2: adresse.adresse2,
        adresse3: adresse.adresse3,
        pays: null,
        ville: ligne.ville,
        codePostal: ligne.codePostal,
        departement: ligne.departement,
        agglomeration: ligne.agglomeration,
        intitule1: null,
        intitule2: null,
        intitule3: null,
        latitude: ligne.latitude,
        longitude: ligne.longitude,
      },
      support: ligne.support,
      localisation: ligne.localisation,
      enAllantVers: ligne.enAllantVers,
      enVenantDe: ligne.enVenantDe,
      angleDeVision: ligne.angleDeVision,
      eclairee: booleanConverter(ligne.eclaire) ?? false,
      proposableLc: true,
      proposableReseau: booleanConverter(ligne.proposableReseau) ?? false,
      produitParDefautId: null,
      affimetrie: {},
      codeFace: ligne.produit,
      faceMotifNonComId: null,
      faceMotifNonCom: ligne.faceMotifNonCom,
      restrictionsAffichage: ligne.restrictionsAffichage,
      disposition: ligne.disposition,
    },
    sens: SENS_VENTE,
    tiersId: null,
    logisticable: true,
    supportCommercialId: supportCommercial.id,
  };
}

function fillProduitWithData(produit, agenceId, fournisseurs, motifs, societe, dictSeq) {
  const confrere = findConfrere(fournisseurs, produit.confrere);

  produit.tiersId = confrere?.id;
  if (!produit.reference) {
    let ref = null;
    if (confrere) {
      ref = generateRef(confrere.nomCommercial);
    } else {
      ref = generateRef(societe.libelle);
    }
    let sequence = 0;
    if (dictSeq[ref]) {
      dictSeq[ref] += 1;
      sequence = dictSeq[ref];
    }
    produit.reference = ref + padStart(sequence, 6, '0');
  }
  if (!produit.codePanneau) {
    produit.codePanneau = produit.reference;
  }

  const motif = motifs.find(
    m => m.libelle?.toLowerCase() === produit.faceMotifNonCom?.toLowerCase(),
  );
  produit.faceMotifNonComId = motif?.id;

  produit.agenceId = agenceId;

  return produit;
}

export default function generationProduits(
  lignes,
  commande,
  societe,
  supports,
  fournisseurs,
  motifs,
  dictSeq,
  produits,
) {
  const supportCommercial = supports.find(s => s.categorieVente === CATEGORIE_UNITAIRE);
  const agenceId = societe.agences.find(
    a => a.libelle.toLowerCase() === commande.agence.toLowerCase(),
  )?.id;
  const results = [];
  for (let i = 0; i < lignes.length; i += 1) {
    let produitToCreate = genererProduit(lignes[i], supportCommercial, produits);
    produitToCreate = fillProduitWithData(
      produitToCreate, agenceId, fournisseurs, motifs, societe, dictSeq,
    );
    // Transmissions de la nouvelle reference pour la creation des lignes de commandes
    lignes[i].produitReference = produitToCreate.reference;

    results.push(produitToCreate);
  }
  return results;
}
